import styles from "./Loading.module.css";

const Loading = () => {
    return (
        <div className={styles.overlay}>
            <div className={styles.spinner}></div>
            <p className={styles.text}>Učitavanje...</p>
        </div>
    );
};

export default Loading;
